import React from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 200;
const SPOTS_LEFT = 14;
export function ScarcityBar() {
  const filled = Math.round((TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100);
  return <div className="w-full rounded-2xl border border-alert/25 bg-alert/[0.06] p-4 sm:p-5" data-id="element-54" data-mp="2l3v34pklwc7f">
      <div className="flex items-start gap-2" data-id="element-55" data-mp="2q37mv1g6l35s">
        <FlameIcon className="mt-0.5 h-4 w-4 shrink-0 text-alert" aria-hidden="true" data-id="element-56" data-mp="2q1wlf8a7k7hu" />
        <p className="text-[13px] font-bold leading-snug text-navy-deep sm:text-sm" data-id="element-57" data-mp="2b5fa2h20qsva">
          Restano solo{' '}
          <span className="text-alert" data-id="element-58" data-mp="2g3ql2v41v9f3">{SPOTS_LEFT} posti</span> al prezzo
          promozionale di questa settimana.
        </p>
      </div>

      <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-navy/10" role="progressbar" aria-valuenow={filled} aria-valuemin={0} aria-valuemax={100} aria-label="Posti già assegnati al prezzo promozionale" data-id="element-59" data-mp="274n3jvkj722p">
        <div className="h-full rounded-full bg-alert" style={{
        width: `${filled}%`
      }} data-id="element-60" data-mp="33mv7qm2i5f6s" />
      </div>

      <div className="mt-2 flex items-center justify-between text-[11px] font-semibold uppercase tracking-[0.08em] text-navy/60" data-id="element-61" data-mp="2zm2y3rppx89z">
        <span data-id="element-62" data-mp="3dc6ew35tw9s1">{filled}% assegnati</span>
        <span data-id="element-63" data-mp="38dlcbx33te0f">
          {TOTAL_SPOTS - SPOTS_LEFT}/{TOTAL_SPOTS}
        </span>
      </div>
    </div>;
}